import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Lenis from "lenis";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import ServicePage from "@/pages/ServicePage";
import ServicesPage from "@/pages/ServicesPage";
import ProductPage from "@/pages/ProductPage";
import B2BPage from "@/pages/B2BPage";
import ArchitectsPage from "@/pages/ArchitectsPage";
import ExportPage from "@/pages/ExportPage";
import CountryPage from "@/pages/CountryPage";
import CityPage from "@/pages/CityPage";
import CitiesHubPage from "@/pages/CitiesHubPage";
import MarketPage from "@/pages/MarketPage";
import { MARKET_SLUGS } from "@/seo/market";
import ContactPage from "@/pages/ContactPage";
import PortfolioPage from "@/pages/PortfolioPage";
import { AnpcPage, CookiesPage, TermeniPage } from "@/pages/LegalPages";
import ProductionPage from "@/pages/ProductionPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminPortfolio from "@/pages/admin/AdminPortfolio";
import { LANGUAGES, LanguageProvider, withLang } from "@/i18n";
import { captureLanding } from "@/lib/tracking";

const PAGES = [
  ["/", <Home />],
  ["/servicii", <ServicesPage />],
  ["/servicii/:slug", <ServicePage />],
  ["/produse/:slug", <ProductPage />],
  ["/productie", <ProductionPage />],
  ["/portofoliu", <PortfolioPage />],
  ["/b2b", <B2BPage />],
  ["/arhitecti", <ArchitectsPage />],
  ["/export", <ExportPage />],
  ["/metallbau-rumaenien", <CountryPage slug="metallbau-rumaenien" />],
  ["/metallerie-roumanie", <CountryPage slug="metallerie-roumanie" />],
  ...MARKET_SLUGS.map((s) => [`/${s}`, <MarketPage slug={s} />]),
  ["/confectii-metalice", <CitiesHubPage />],
  ["/confectii-metalice/:city", <CityPage />],
  ["/contact", <ContactPage />],
  ["/termeni-conditii", <TermeniPage />],
  ["/anpc", <AnpcPage />],
  ["/politica-cookies", <CookiesPage />],
];

function App() {
  useEffect(() => {
    captureLanding();
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <LanguageProvider>
          <Routes>
            <Route element={<Layout />}>
              {LANGUAGES.flatMap((l) =>
                PAGES.map(([p, el]) => <Route key={`${l.code}${p}`} path={withLang(l.code, p)} element={el} />)
              )}
              <Route path="*" element={<Home />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Navigate to="/admin/lead-uri" replace />} />
              <Route path="lead-uri" element={<AdminLeads />} />
              <Route path="portofoliu" element={<AdminPortfolio />} />
            </Route>
          </Routes>
        </LanguageProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
